import React, { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  // componentDidCatch(error, errorInfo) {
  //   console.error("Error caught by Error Boundary:", error, errorInfo);
  // }

  render() {
    if (this.state.hasError) {
      return <h2 className="center-conten">Something went wrong.</h2>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
